import { Component, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VerifyEmailService } from './services/verify-email.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css']
})
export class VerifyEmailComponent {
  message:string = '';
  isSuccess:Number = 0;
  isConsent:Number = 0;
  isConsentMessage:string = '';
  isLoaded:boolean = false;
  urlId:string = "";
  public modalRef: BsModalRef;
  public isChecked:boolean = false;
  public isOpened:boolean = false;
  isSignup:boolean = false;
  constructor(public dialog: BsModalService,private route: ActivatedRoute,private verifyEmailService:VerifyEmailService){
   this.route.queryParams.subscribe(params => {
     
    const urlId =  encodeURIComponent(params['id']);
    this.urlId = urlId;

    this.verifyEmailService.sendVerificationEmail(urlId).subscribe(res => {
      this.isSuccess = res.data.errorCode;
      this.message = res.data.msg;
      this.isLoaded = true;
    });
  });
  
 }

 onCheckboxChange(e) {
    this.isChecked = e.target.checked;
 }

  onAcknowlegement(tpl: TemplateRef<any>){
    this.verifyEmailService.IsACKConsentUpdation(this.urlId).subscribe(res => {
       this.isConsent = 1;
      // this.isSuccess = res.data.errorCode;
       this.isConsentMessage = 'eConsent updated successfully.';
       this.isLoaded = true;
       this.modalRef=this.dialog.show(tpl);
       this.isSignup = true;
    });
  }
  onClose(e) {
    this.isOpened = false;
    this.modalRef.hide();
   // this.closeAllModals();
   
}
onNoThanks(tpl: TemplateRef<any>) {
   if(!this.isOpened){
    this.isOpened = true;
    this.verifyEmailService.IsACKConsentNoThankUpdation(this.urlId).subscribe(res => {
      this.isLoaded = true;
      this.modalRef = this.dialog.show(tpl);
  });
  }else{
    this.isOpened = false;
    this.modalRef.hide();
  }
}
closeAllModals() {
  for (let i = 1; i <= this.dialog.getModalsCount(); i++) {
    this.dialog.hide(i);
  }
}
}
